import React from 'react';
import styles from './TemplateCard.module.scss';
import PropTypes from 'prop-types';

export default function TemplateCard ({ image, templateId }) {
    return (
        <>
            <div className={`${styles.container} ${styles[`template${templateId}`]}`}>
                {image && <img src={`${image}`} alt='template' />}
            </div>
        </>
    );
}

TemplateCard.propTypes = {
    image: PropTypes.string,
    templateId: PropTypes.number
};
